import { AccountActionConstants } from "../action-constants";
import EmptyState from "../store/emptyState";
import globalReducerHelper from "./globalReducerHelper";

const {
  TOGGLE_ACCOUNT_DRAWER,
  TOGGLE_MINI_CASHIER_DRAWER,
  TOOGLE_ACCOUNT_REWARDS_DRAWER
} = AccountActionConstants;

const account = (state = EmptyState.account, action) => {
  if (!state) {
    return {};
  }

  const { type, payload } = action;

  switch (action.type) {
    case TOGGLE_ACCOUNT_DRAWER: {
      const newDrawerActive = !state.drawerActive;
      return Object.assign({}, state, {
        drawerActive: newDrawerActive,
        initialized: true
      });
    }

    case TOGGLE_MINI_CASHIER_DRAWER:
      return Object.assign({}, state, {
        miniCashierDrawerActive: !state.miniCashierDrawerActive,
        initialized: true
      });

    case TOOGLE_ACCOUNT_REWARDS_DRAWER: {
      const newRewardDrawerActive = !state.rewardDrawerActive;
      return Object.assign({}, state, {
        rewardDrawerActive: newRewardDrawerActive,
        initialized: true
      });
    }
    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.account,
        EmptyState.account
      );
  }
};

export default account;
